// extracted by mini-css-extract-plugin
export default {"btn":"Cart_btn__O-5cl","btns":"Cart_btns__dfc6M","warning":"Cart_warning__bpaDa"};